export default __webpack_public_path__ + "static/media/finecart-logo.61e132a7.png";